import Dropzone from 'dropzone';
window.Dropzone = Dropzone;
Dropzone.autoDiscover = false;

Dropzone.prototype.defaultOptions.dictDefaultMessage = "Klik of sleep je foto's naar hier om ze te uploaden.";
Dropzone.prototype.defaultOptions.dictFallbackMessage = "Your browser does not support drag'n'drop file uploads.";
Dropzone.prototype.defaultOptions.dictFallbackText = "Please use the fallback form below to upload your files like in the olden days.";
Dropzone.prototype.defaultOptions.dictFileTooBig = "Deze foto is te groot ({{filesize}}MiB). Maximum grootte: {{maxFilesize}}MiB.";
Dropzone.prototype.defaultOptions.dictInvalidFileType = "You can't upload files of this type.";
Dropzone.prototype.defaultOptions.dictResponseError = "Server responded with {{statusCode}} code.";
Dropzone.prototype.defaultOptions.dictCancelUpload = "Cancel upload";
Dropzone.prototype.defaultOptions.dictCancelUploadConfirmation = "Are you sure you want to cancel this upload?";
Dropzone.prototype.defaultOptions.dictRemoveFile = "Remove file";
Dropzone.prototype.defaultOptions.dictMaxFilesExceeded = "You can not upload any more files.";

$(document).ready(function() {
    if ($('.business-gallery-editor').length > 0) {
        businessGalleryEditor.initiate();
    }
});

var businessGalleryEditor = {
    initiate: function() {
        var dropzone = new Dropzone("#drop_zone", {
            maxFilesize: 20
        });

        dropzone.on('success', function(file, response) {
            dropzone.removeFile(file);

            $('#no_images').hide();

            var el = '<div class="col-md-2">';
            el += '<img src="' + response.url + '">';
            el += '<a class="delete-image" href="#" data-image-id="' + response.id + '">Verwijder</a>';
            el += '</div>';

            $('.uploaded-images').append(el);
        });

        $(document).on('click', 'a.delete-image', function(e) {
            e.preventDefault();
            var imageEl = $(this).parent();

            $.post('/api/business/delete-image/' + $(this).data('image-id'), function() {
                imageEl.remove();
            });
        });
    }
};
